"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-foundation-components/~/react-overlays/~/dom-helpers/util/camelize.js
 ** module id = 1073
 ** module chunks = 0
 **/